module.exports = __webpack_public_path__ + "media/images/newsletter/newsletter-the-checklist-f1c859b378e76b70751d15b17156a5c9.png";